import React, {useState} from 'react';

import {MiniDrawer} from "../misc/mini-drawer/mini-drawer";
import {TOOLTIP_PLACEMENT} from "../tooltip/tooltip-consts";
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {APP} from "../../app/consts";
import {TrashIcon} from "../trash/trash-icon-component";
import {DeviceViewModel} from "../../models/device.view-model";
import {UseDevice} from "../composers/composer-plugins/use-device";
import {StarSelection} from "../entity-selection/star-selection";

export class MiniDrawerStarIconComponentProps extends BaseProps {
  type: String;
  alwaysOpen: Boolean;
  openFromLeft: Boolean;
  isActive: Boolean;
  hideActiveBorder: Boolean;
  id: Number;
  extraIds: Array;
  sportTypeId: Number;
  date: Date;
  sourceScreen: String;
  source: APP.ANALYTICS.SOURCES;
  disabled: Boolean;
  isRemoveOnly: Boolean;
  onClick: Function;
  includeTransparentBorder: Boolean;
  subSource: String;
  className: String;
  drawerClassName: String;
  placement: String;
  device: DeviceViewModel;
}

export const MiniDrawerStarIcon = UseDevice()((props: MiniDrawerStarIconComponentProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isActive, setIsActive] = useState(false);

  if (props.disabled) {
    return props.children;
  }

  const drawerContentProps = {
    id: props.id,
    type: props.type,
    date: props.date,
    sourceScreen: props.sourceScreen,
    extraIds: props.extraIds,
    placement: props.device.isRtl ? TOOLTIP_PLACEMENT.right : TOOLTIP_PLACEMENT.left,
    source: props.source,
    sportTypeId: props.sportTypeId,
    subSource: props.subSource,
    placementGA: props.placement,
    className: props.openFromLeft ? (isOpen ? 'star-icon-spin-open' : 'star-icon-spin-close') : (isOpen ? 'star-icon-spin-close' : 'star-icon-spin-open'),
    onChange: (isActive) => setIsActive(isActive),
    device: props.device
  }

  const miniDrawerClassName: String = [props.className, 'mini-drawer-start-icon', props.device.isRtl ? 'mini-drawer-rtl' : 'mini-drawer-ltr', props.openFromLeft ? 'open-from-left' : 'open-from-right',
    props.includeTransparentBorder ? 'active-transparent' : '', (isActive && !props.hideActiveBorder) ? 'active-secondary' : ''].join(' ')

  const drawerProps = {
    DrawerContent: props.isRemoveOnly ? TrashIcon : StarSelection,
    drawerContentProps,
    alwaysOpen: props.alwaysOpen,
    onOpenStateChange: (isOpen) => setIsOpen(isOpen),
    width: props.width || 32,
    openFromLeft: props.openFromLeft,
    className: [miniDrawerClassName, 'mini-drawer-star-icon-container', props.className,
      props.device.isRtl ? 'mini-drawer-rtl' : 'mini-drawer-ltr', props.openFromLeft ? 'open-from-left' : 'open-from-right',
      props.includeTransparentBorder ? 'active-transparent' : '', (isActive && !props.hideActiveBorder) ? 'active-secondary' : ''].join(' '),
    drawerClassName: ['mini-drawer-star-icon-drawer', 'mini-drawer-star-icon-drawer-container', props.isRemoveOnly ? 'mini-drawer-star-icon-remove-only' : '', props.drawerClassName].join(' '),
    device: props.device
  }

  return (
    <MiniDrawer {...drawerProps} >
      {
        props.children
      }
    </MiniDrawer>
  );
});
